import { InjectionToken } from '@angular/core';

// https://angular.io/api/forms/Validators
export const defaultErrors = {
    min: ({ min, actual }) => `Must be at least ${min}.`,
    max: ({ max, actual }) => `Must not be more than ${max}.`,
    required: (error) => `This field is required.`,
    requiredTrue: (error) => `This field is required to be true.`,
    email: (error) => `Invalid email format.`,
    minlength: ({ requiredLength, actualLength }) => `Must be at least ${requiredLength} characters long.`,
    maxlength: ({ requiredLength, actualLength }) => `Must not be longer than ${requiredLength} characters.`,
    pattern: ({ requiredPattern, actualValue }) => `Invalid format.`,
    notSame: (error) => `Does not match.`,
    passwordRequirements: (error) => `Does not meet the character requirements.`,
};

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
    providedIn: 'root',
    factory: () => defaultErrors
});
